import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.last-index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { addOrUpdateEntry } from "@/api/chatbot/chatbot";
import util from '@/libs/util';
import axios from 'axios';
export default {
  name: "addDocumetItem",
  mixins: [tabulation],
  data: function data() {
    var _this = this;

    var validateFile = function validateFile(rule, value, callback) {
      if (_this.paramsData.type === 'upload' && !_this.paramsData.file) {
        callback(new Error('请选择要上传的文件'));
      } else {
        callback();
      }
    };

    var validateJson = function validateJson(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        try {
          JSON.parse(value);
          callback();
        } catch (e) {
          callback(new Error('输入的哈希文本不符合标准 JSON 格式，请检查语法'));
        }
      }
    };

    return {
      dialog: false,
      fileList: [],
      paramsData: {
        type: 'text',
        // 默认激活文本输入框
        content: '',
        file: null,
        // 原生抓取并匹配业务的字段
        version: 'v1',
        title: '',
        kind: 'table_description',
        priority: 80,
        enabled: 'false',
        document_type: '',
        table_name: '',
        column_name: '',
        keywords: '',
        tags: '',
        relation_type: '',
        schema_linking_focus: '',
        related_tables: '',
        related_columns: '',
        context_columns: '',
        generator_context_max_chars: 0,
        generator_summary: '',
        metadata: ''
      },
      rules: {
        type: [{
          required: true,
          message: "请选择上传类型",
          trigger: "change"
        }],
        title: [{
          required: true,
          message: "请输入标题",
          trigger: "blur"
        }],
        kind: [{
          required: true,
          message: "请选择类型",
          trigger: "change"
        }],
        content: [{
          required: true,
          message: "请输入内容说明",
          trigger: "blur"
        }],
        file: [{
          required: true,
          validator: validateFile,
          trigger: "change"
        }],
        metadata: [{
          validator: validateJson,
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  Object.keys(_this2.paramsData).forEach(function (key) {
                    if (data[key] !== undefined) {
                      _this2.paramsData[key] = data[key];
                      _this2.paramsData.metadata = data.metadata_json;
                    }
                  });
                }

                _this2.dialog = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleTypeChange: function handleTypeChange() {
      this.paramsData.content = '';
      this.paramsData.file = null;
      this.fileList = [];
      this.$refs.ruleForm.clearValidate(['content', 'file']);
    },
    // 文件选择与格式体积校验
    handleFileChange: function handleFileChange(file, fileList) {
      var allowedExtensions = ['txt'];
      var fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      var isSizeValid = file.size / 1024 / 1024 < 50;

      if (!allowedExtensions.includes(fileExtension)) {
        this.$message.error('上传文件只能是 .txt 格式!');
        this.fileList = [];
        this.paramsData.file = null;
        return false;
      }

      if (!isSizeValid) {
        this.$message.error('上传文件大小不能超过 50MB!');
        this.fileList = [];
        this.paramsData.file = null;
        return false;
      }

      this.fileList = fileList;
      this.paramsData.file = file.raw;
      this.$refs.ruleForm.validateField('file');
    },
    handleFileRemove: function handleFileRemove() {
      this.fileList = [];
      this.paramsData.file = null;
      this.$refs.ruleForm.validateField('file');
    },
    handleExceed: function handleExceed() {
      this.$message.warning('只能上传单个文件，请先删除已有文件。');
    },
    resetForm: function resetForm() {
      this.dialog = false;
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this3.paramsData.type == 'text') {
            console.log("this.paramsData", _this3.paramsData);
            var data = JSON.parse(JSON.stringify(_this3.paramsData));
            data.context_columns = data.context_columns ? data.context_columns.split(",") : [];
            data.keywords = data.keywords ? data.keywords.split(",") : [];
            data.related_columns = data.related_columns ? data.related_columns.split(",") : [];
            data.related_tables = data.related_tables ? data.related_tables.split(",") : [];
            data.tags = data.tags ? data.tags.split(",") : [];
            data.metadata = data.metadata ? JSON.parse(data.metadata) : {};
            data.enabled = JSON.parse(data.enabled);
            console.log("da====", data);
            data.entry_id = '', delete data.type;
            delete data.file;
            var reqFn = "/analysis-chat/add-or-update-entry";
            axios.post(process.env.VUE_APP_API + reqFn, data, {
              headers: {
                "Content-Type": 'application/json',
                "Authorization": 'Bearer ' + (util.cookies.get('token') || ''),
                "Request-Url": _this3.$route.path
              }
            }).then(function (res) {
              if (res.detail) {
                _this3.$message({
                  type: "error",
                  message: res.detail
                });
              } else {
                _this3.$emit('change');

                _this3.$message({
                  type: "success",
                  message: '新增成功'
                });
              }

              _this3.dialog = false;
            });
          } else {
            var formData = new FormData();
            formData.append('entry_id', '');
            formData.append('version', _this3.paramsData.version);
            formData.append('title', _this3.paramsData.title);
            formData.append('kind', _this3.paramsData.kind);
            formData.append('priority', _this3.paramsData.priority);
            formData.append('enabled', _this3.paramsData.enabled);
            formData.append('doc_type', _this3.paramsData.document_type); // 契合接口的 doc_type

            formData.append('table_name', _this3.paramsData.table_name);
            formData.append('column_name', _this3.paramsData.column_name);
            formData.append('keywords', _this3.paramsData.keywords);
            formData.append('tags', _this3.paramsData.tags);
            formData.append('relation_type', _this3.paramsData.relation_type);
            formData.append('schema_linking_focus', _this3.paramsData.schema_linking_focus);
            formData.append('related_tables', _this3.paramsData.related_tables);
            formData.append('related_columns', _this3.paramsData.related_columns);
            formData.append('context_columns', _this3.paramsData.context_columns);
            formData.append('generator_context_max_chars', _this3.paramsData.generator_context_max_chars);
            formData.append('generator_summary', _this3.paramsData.generator_summary);
            formData.append('metadata', _this3.paramsData.metadata);

            if (_this3.paramsData.type === 'text') {
              formData.append('content', _this3.paramsData.content);
            } else if (_this3.paramsData.type === 'upload' && _this3.paramsData.file) {
              formData.append('file', _this3.paramsData.file); // 键名为要求传递的 'file'
            }

            var _reqFn = "/analysis-chat/import-entry";
            axios.post(process.env.VUE_APP_API + _reqFn, formData, {
              headers: {
                "Content-Type": 'multipart/form-data',
                "Authorization": 'Bearer ' + (util.cookies.get('token') || ''),
                "Request-Url": _this3.$route.path
              }
            }).then(function (res) {
              if (res.data.detail) {
                _this3.$message({
                  type: "error",
                  message: res.data.detail
                });
              } else {
                _this3.$emit('change');

                _this3.$message({
                  type: "success",
                  message: '新增成功'
                });
              }

              _this3.dialog = false;
            });
          }
        }
      });
    },
    clearData: function clearData() {
      this.paramsData = {
        type: 'text',
        // 默认激活文本输入框
        content: '',
        file: null,
        // 原生抓取并匹配业务的字段
        version: 'v1',
        title: '',
        kind: 'table_description',
        priority: 80,
        enabled: 'false',
        document_type: '',
        table_name: '',
        column_name: '',
        keywords: '',
        tags: '',
        relation_type: '',
        schema_linking_focus: '',
        related_tables: '',
        related_columns: '',
        context_columns: '',
        generator_context_max_chars: 0,
        generator_summary: '',
        metadata: ''
      };
      this.fileList = [];
      this.$refs.ruleForm.resetFields();
    }
  }
};